/**
 * Gallery Swiper Script
 * Initializes Swiper carousel with cards effect for gallery
 */

(function() {
  'use strict';

  /**
   * Initialize gallery swiper
   */
  function initGallerySwiper() {
    // Check if Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.error('❌ Swiper library not loaded');
      return;
    }

    const swiperElement = document.querySelector('.gallery-swiper');
    
    if (!swiperElement) {
      console.warn('⚠️ Gallery swiper element not found');
      return;
    }

    // Initialize Swiper with cards effect
    const swiper = new Swiper('.gallery-swiper', {
      effect: 'cards',
      grabCursor: true,
      cardsEffect: {
        perSlideOffset: 12,
        perSlideRotate: 0,    // No rotation
        rotate: false,         // Disable rotation
        slideShadows: true,
      },
      navigation: {
        nextEl: '.gallery__nav-btn--next',
        prevEl: '.gallery__nav-btn--prev',
      },
      keyboard: {
        enabled: true,
      },
      loop: false, // Disable loop for better cards effect navigation
      speed: 600,
      allowTouchMove: true,
      on: {
        init: function() {
        }
      }
    });
  }

  // With defer attribute, scripts run after DOM is ready
  // Just check if DOM is already loaded or wait for it
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallerySwiper);
  } else {
    // DOM is already ready, init immediately
    initGallerySwiper();
  }

})();
